import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getAll = async ( params = {}) => {
  const query = `
    query AllPacientes(
      $search          : String,
      $tokenPaciente   : String,
      $establecimiento : String,
      $fechaDesde      : String,
      $fechaHasta      : String,
      $observaciones   : String,
      $page            : Int,
      $pageSize        : Int,
      $idPaciente      : ID,
      $historiaClinica : String
    ) {
      allPacientes(
        search          : $search
        tokenPaciente   : $tokenPaciente
        establecimiento : $establecimiento
        fechaDesde      : $fechaDesde
        fechaHasta      : $fechaHasta
        observaciones   : $observaciones
        page            : $page
        pageSize        : $pageSize
        idPaciente      : $idPaciente
        historiaClinica : $historiaClinica
      ) {
        status
        total
        message
        paciente {
          id
          token
          numHistoriaClinica
          tipoCobertura
          segsalud {
            id
            descripcion
            codigo
          }
          seguroprivado {
            id
            descripcion
          }
          usuarioCreador{
            username
          }
          fechaCreacion
          persona {
            correo
            telefono
            
            id
            token
            primerApellido
            identificacion
            primerNombre
            estadoCivil
            esDiscapacitado
            sexo
            fechaNacimiento
            urlIdentificacion
            urlCarnetIssfa
            urlCarnetIsspol
            urlCarnet
            nivelEducacion {
              id
              descripcion
            }
            ocupacion {
              id
              descripcion
            }
            nacionalidad {
              id
              descripcion
            }
            nacionalidadEtnia {
              id
              descripcion
            }
            pueblokichwa {
              id
              descripcion
            }
            residencia {
              id
              pais {
                id
                provinciaSet {
                  id
                  descripcion
                }
                descripcion
              }
              callePrincipal
              calleSecundaria
              barrio
              parroquia
              canton {
                id
                descripcion
                idprovincia{
                  descripcion
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    ...params
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    
    const response2 = response.data.data.allPacientes;
    if(response2.status !== 'success') return null;
    
    const data = {
      pacientes: response2.paciente,
      total: response2.total
    }

    return data;

  }catch(error){
    console.log(error);
    return null;
  }
} 


const createPaciente = async ( fields ) => {

  const query = `
    mutation CreatePaciente(
      $persona             :String!
      $numHistoriaClinica  :String!
      $seguroSalud         :String!
      $seguroPrivado       :String
      $tipoCobertura       :String
      $establecimiento     :String
    ) {
      createPaciente(
        persona             : $persona
        numHistoriaClinica  : $numHistoriaClinica
        seguroSalud         : $seguroSalud
        seguroPrivado       : $seguroPrivado
        tipoCobertura       : $tipoCobertura
        establecimiento     : $establecimiento
      ) {
        message
        status
        paciente {
          id
          token
        }
      }
    }
  `;


  const variables = {
    persona             : fields?.persona             || '',
    numHistoriaClinica  : fields?.numHistoriaClinica  || '',
    seguroSalud         : fields?.seguroSalud         || '',
    seguroPrivado       : fields?.seguroPrivado       || '',
    tipoCobertura       : fields?.tipoCobertura       || '',
    establecimiento     : fields?.establecimiento     || '',
  }
  

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.createPaciente;

    if(response2.status !== 200) return null;

    const data = response2.paciente;
    return data;

  }catch( error ){
    console.error('error al crear paciente', error);
    return null;
  }
}


const updateByToken = async ( tokenPaciente, dataPaciente ) => {
  
  if(!tokenPaciente) {
    console.error('no hay token para actualizar paciente');
    return null;
  }

  const query = `
    mutation updateByToken(
      $tokenPaciente  : String!
      $idPersona      : String
      $historiaClinica: String
      $establecimiento: String
    ) {
      actualizarPaciente(
        tokenPaciente  : $tokenPaciente
        idPersona      : $idPersona
        historiaClinica: $historiaClinica
        establecimiento: $establecimiento
      ) {
        status
        message
        paciente {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenPaciente,
    idPersona      : dataPaciente?.idPersona          || '',
    historiaClinica: dataPaciente?.numHistoriaClinica || '',
    establecimiento: dataPaciente?.establecimiento    || '',
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.actualizarPaciente;

    if(response2.status !== 'success') return response2.message;

    const data = response2.paciente;
    return data;

  }catch( error ){
    console.error('error al actualizar paciente', error);
    return error;
  }
}


const searchPacientesByTerm = async (
  search = '', 
  fields = ['primerNombre', 'primerApellido', 'identificacion', 'fechaNacimiento']
) => {

  const queryFields = fields.join(',');

  const query = `
    query MyQuery($search: String) {
      allPacientes(search: $search) {
        status
        total
        paciente {
          id
          token
          numHistoriaClinica
          persona {
            id
            telefono
            ${queryFields}
          }
        }
      }
    }
  `;
  const variables = { search }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );

    const response2 = response.data.data.allPacientes;
    if(response2.status !== 'success') return null;

    const data = response2.paciente;
    return data;

  } catch (error) {
    console.error("Error fetching pacientes:", error);
    return null;
  }
}


const searchPacientesByTermSelect = async (search) => {
  
  const response = await searchPacientesByTerm(search);

  const data = response.map(item => ({
    ...item,
    value: item.id,
    text: `${item.persona.identificacion} - ${item.persona.primerApellido} ${item.persona.primerNombre}`, 
  }));

  return data;
}



const searchByHistoriaClinica = async (historiaClinica, establecimiento) => {

  const params = { historiaClinica, establecimiento };
  const response = await getAll(params);

  if(!response) return null;
  const data = response.pacientes[0];
  return data;
}



export const pacientesService = {
  getAll,
  createPaciente,
  updateByToken,

  searchPacientesByTerm,
  searchPacientesByTermSelect,
  searchByHistoriaClinica
}
